export default __webpack_public_path__ + "static/media/mothra.e6dc0e38.png";